import { render } from "./BaseFilterHorizontal.vue?vue&type=template&id=0667b654"
import script from "./BaseFilterHorizontal.vue?vue&type=script&lang=js"
export * from "./BaseFilterHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__